import AssessmentIcon from '@mui/icons-material/Assessment';
import ResultList from './ResultList';

const results = {
  list: ResultList,
  icon: AssessmentIcon,
};

export default results;
export { results };
